// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"197d7280","256":"4b63efea","311":"f7dfce1f","384":"b391726d"}[chunkId] + ".chunk.css";
};